<template>
  <div class="product">
    <TopCN title="ANTDIY"
    title2="为中小跨境卖家提供一站式解决方案"
      subtitle="通过ANTDIY您可以快速把成千上万的商品从1688、淘宝、拼多多等货源平台快速铺货到全球各大电商主流平台及站点，借助一站式服务，你无需囤货，无需库存，无需亲自打包发货，无需专业团队，也能轻松通过跨境卖家爆单赚外币"
      btn="免费试用" img="/static/imgs/productcn1.svg" bg='top_bg_z' ></TopCN>
    <Sidebanner></Sidebanner>
    <div class="product_situation">
      <div class="product_situationbox">
        <h2 class="product_situationbox_title">ANTDIY业务场景</h2>
        <h3 class="product_situationbox_subtitle">从商品采集、选品、刊登、采购到发货一站统统帮您搞定</h3>
        <div class="product_situationbox_line"></div>
        <div class="product_img"><img src="../assets/productcn2.svg" alt="ANTDIY业务场景"  ></div>
      </div>
    </div>
    <div class="product_situation2">
      <div class="product_situationbox product_situationbox3">
        <h2 class="product_situationbox_title">跨境电商一站式解决方案</h2>
        <h3 class="product_situationbox_subtitle">您专注卖货-爆单-收钱,其他的,统统交给我们帮您一站搞定！</h3>
        <div class="product_situationbox_line"></div>
        <div class="product_planbox1">
          <h3 class="product_planbox1_title" >传统跨境，道阻且长</h3>
          <div><img src="../assets/productcn3.svg" alt="传统跨境，道阻且长" ></div>
        </div>
        <div class="product_planbox2">
          <h3 class="product_planbox1_title">ANTDIY系统+生态服务 实现轻资产，高效率的跨境电商路径</h3>
          <div><img src="../assets/productcn4.svg" alt="ANTDIY系统+生态服务 实现轻资产，高效率的跨境电商路径" ></div>
        </div>
        <div class="product_planbox_bottom">
          <!-- <div class="product_planbox_button1" v-if="isconsult">一站式服务套餐</div> -->
          <div class="product_planbox_button2" v-if="consultion" @click="consult">立即咨询</div>
        </div>
      </div>
    </div>
    <div class="product_situation">
      <div class="product_situationbox">
        <h2 class="product_situationbox_title">特色功能</h2>
        <h3 class="product_situationbox_subtitle">智能极致，简单易用，让您事半功倍</h3>
        <div class="product_situationbox_line"></div>
        <div class="procuct_antools_line">
          <div class="procuct_antools_column">
            <div class="procuct_antools_circle"></div>
            <img class="procuct_antools_image" src="../assets/productcn5.svg" alt="产品采集">
            <div class="procuct_antools_title">产品采集</div>
            <div class="procuct_antools_text">支持多平台，按链接、店铺、关键词等多种商品采集方式</div>
          </div>
          <div class="procuct_antools_column">
            <div class="procuct_antools_circle"></div>
            <img class="procuct_antools_image" src="../assets/productcn6.svg" alt="多店铺管理">
            <div class="procuct_antools_title">多店铺管理</div>
            <div class="procuct_antools_text">解决一平台一人一店铺难题，让用户实现一个刊登账号授权一平台一人多店铺，避免了账号关联，无封店风险</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn7.svg" alt="产品搬家">
            <div class="procuct_antools_title">产品搬家</div>
            <div class="procuct_antools_text">支持同平台、跨平台产品资料互搬，助力买家快速开拓新站点、新店铺</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn8.svg" alt="智能草稿">
            <div class="procuct_antools_title">智能草稿</div>
            <div class="procuct_antools_text">一份源草稿智能生成多份不同的草稿，单产品铺货到多店铺无需担心关联</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn9.svg" alt="产品中心">
            <div class="procuct_antools_title">产品中心</div>
            <div class="procuct_antools_text">产品资料中心化管理，一次维护即可在多平台多店铺间共享，一键生成不同平台的产品草稿，上架更轻松</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn10.svg" alt="图片编辑">
            <div class="procuct_antools_title">图片编辑</div>
            <div class="procuct_antools_text">支持图片在线编辑，一键抠图、美图， 尺寸调整、自由裁剪、图片翻译等</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn11.svg" alt="开店指导">
            <div class="procuct_antools_title">开店指导</div>
            <div class="procuct_antools_text">产品描述支持嵌入视频，视频素材一键上传托管，一视频一链接不关联，全球加速，老外看也不卡顿</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn12.svg" alt="一键翻译">
            <div class="procuct_antools_title">一键翻译</div>
            <div class="procuct_antools_text">支持214种语言互译，采集的商品可一键翻译并直接刊登到不同平台</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn13.svg" alt="批量修改">
            <div class="procuct_antools_title">批量修改</div>
            <div class="procuct_antools_text">多个产品需要更改某个字段，只需批量编辑字段，统一修改，省时省力</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn14.svg" alt="快速编辑">
            <div class="procuct_antools_title">快速编辑</div>
            <div class="procuct_antools_text">在列表中，即可对产品的某个信息做更改，无需跳转编辑页面，快速可靠</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn15.svg" alt="订单处理">
            <div class="procuct_antools_title">订单处理</div>
            <div class="procuct_antools_text">在线处理平台订单，订单审核后自动同步到云仓</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/productcn16.svg" alt="自动标发">
            <div class="procuct_antools_title">自动标发</div>
            <div class="procuct_antools_text">云仓根据订单信息，打包发货成功后，发货信息自动同步到平台</div>
          </div>
        </div>
        <div class="product_antools_bottom product_antools_bottom2">
          <!-- <div class="product_planbox_button2">更多功能</div> -->
          <div class="product_planbox_button2" @click="consult">立即咨询</div>
        </div>
      </div>
    </div>
    <div class="form_background">
      <div class="product_situationbox product_situationbox2">
        <h2 class="product_situationbox_title">主流平台无忧接入</h2>
        <h3 class="product_situationbox_subtitle">智能极致，简单易用，让您事半功倍</h3>
        <div class="product_situationbox_line"></div>
        <div></div>
        <div class="product_platform">
          <div class="product_platform_line"></div>
          <p class="product_platform_p" >采集支持平台</p>
          <div class="product_platform_line"></div>
        </div>
        <div class="product_background">
        <div class="product_type">
          <div class="product_type_box" v-for="(item,index) in typelist" :key="index">
            <img :src=item.url :alt=item.name :class=item.name>
          </div>
        </div>
        <div class="product_type2">
          <div class="product_type_box">
            <img src="/static/imgs/productcn23.png" alt="">
          </div>
          <div class="product_type_box">
            <p>更多平台待接入…</p>
          </div>
        </div>
        <div class="product_platform">
          <div class="product_platform_line"></div>
          <p class="product_platform_p">刊登支持平台</p>
          <div class="product_platform_line"></div>
        </div>
        <div class="product_type">
          <div class="product_type_box" v-for="(item,index) in typelist2" :key="index">
            <img :src=item.url :alt=item.name >
          </div>
        </div>
        <div class="product_type3">
          <div class="product_type_box">
            <img src="/static/imgs/productcn29.png" alt="ozon">
          </div>
          <div class="product_type_box">
            <img src="/static/imgs/productcn30.png" alt="cdiscount" class="cdiscount">
          </div>
          <div class="product_type_box">
            <img src="/static/imgs/productcn31.png" alt="coupang">
          </div>
          <div class="product_type_box">
            <img src="/static/imgs/productcn32.png" alt="shopee">
          </div>
        </div>
        <div class="product_type2">
          <div class="product_type_box">
            <img src="/static/imgs/productcn33.png" alt="allegro">
          </div>
          <div class="product_type_box">
            <img src="/static/imgs/productcn34.png" alt="newegg" class="newegg">
          </div>
        </div>
        <p class="product_platform_title">我们支持以上平台的代入驻服务，让您开店更省心。</p>
        <div class="product_platform_button" @click="openstore"><p>立即开店</p><img src="../assets/arrow.svg" alt="arrow"></div>
        </div>
      </div>   
    </div>
    <div class="product_situation3">
      <div class="product_situationbox">
        <h2 class="product_situationbox_title">众多优秀企业的信赖之选</h2>
        <div class="product_display_line"></div>
        <DisPlay :sayList="sayList" name=".product_situation3" cater="2" count='2'></DisPlay>
      </div>
    </div>
     <div class="product_situation2">
      <div class="product_situationbox">
        <h2 class="product_situationbox_title">核心优势</h2>
        <h3 class="product_situationbox_subtitle">选择我们,专业体贴，与您共赢</h3>
        <div class="product_situationbox_line"></div>
        <div class="product_strength">
          <div class="product_strength_box">
            <div ><img src="../assets/productcn37.svg" alt="顾问服务"></div>
            <p class="product_strength_box_title">顾问服务</p>
            <p class="product_strength_box_subtitle">定期线上,线下培训及卖家交流活动</p>
          </div>
            <div class="product_strength_box">
            <div><img src="../assets/productcn38.svg" alt="专业培训"></div>
            <p class="product_strength_box_title">专业培训</p>
            <p class="product_strength_box_subtitle">专业体贴的售前顾问团队，根据您的业务场景，为您量身打造更适合您的独特产品方案</p>
          </div>
            <div class="product_strength_box">
           <div><img src="../assets/productcn39.svg" alt="极致客服"></div>
            <p class="product_strength_box_title">极致客服</p>
            <p class="product_strength_box_subtitle">即时在线聊天，400电话全天候在线，3分钟快速响应，问题全程跟踪，闭环解决</p>
          </div>
            <div class="product_strength_box">
            <div><img src="../assets/productcn40.svg" alt="优质资源"></div>
            <p class="product_strength_box_title">优质资源</p>
            <p class="product_strength_box_subtitle">免费为您对接开店入驻，运营培训，供应链，云仓代打包，代采购，海外仓及国际物流服务</p>
          </div>
        </div>
        <div class="product_strength_line"></div>
        <div class="product_strength_div">进一步了解ANTDIY</div>
        <div class="product_antools_bottom">
          <div class="product_planbox_button2" @click="changeroute()">解决方案</div>
          <div class="product_planbox_button2" @click="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)">免费试用</div>
        </div>
    </div>
    </div>
    <div class="form_back" v-if='form'>
      <form >
      <h1>开店申请</h1>
      <img src="../assets/closeform.svg" alt="" class="form_close" @click="close">
      <div class="form_line">
        <em></em>
        <div class="form_block"></div>
      </div>
      <img :src="`/static/imgs/${picture}1.svg`" alt="" class="form_img" v-if='content'>
      <img :src="`/static/imgs/${picture}2.svg`" alt="" class="form_img" v-else>
      <div class="form_content" v-if='content'>
        <div class="form_content_item"><label>公司名称：</label><input type="text" placeholder="请输入您的公司名称" v-model="company"></div>
        <div class="form_content_item"><label>经营地址：</label><input type="text" placeholder="请输入您的经营地址" v-model="address"></div>
        <Choosebox :lidata="lidata" title="公司规模：" :selected="listtable" @click="change($event,1)" ></Choosebox>
        <div class="form_content_item form_content_item2">
          <label><div class="form_content_item_necessary"><img src="../assets/necessary.svg" alt="">联系人姓名：</div></label>
          <div class="form_content_item_input">
          <input type="text" placeholder="请输入您的姓名" v-model="name" @input="write(1)">
          <span class="form_content_item_error" v-if="errorname">请输入姓名</span>
          </div> 
        </div>
        <div class="form_content_item form_content_item3">
          <label><div class="form_content_item_necessary"><img src="../assets/necessary.svg" alt="">手机号：</div></label>
          <div class="form_content_item_input">
          <input type="text" placeholder="请输入您的手机号" v-model="phone" @input="write(2)">
          <span class="form_content_item_error"  v-if="errorphone">请输入正确手机号</span>
          </div> 
        </div>
        <Choosebox :lidata="lidata2" title="正在运营的平台：" :selected="listtable2" @click="change($event,2)"></Choosebox>
        <Choosebox :lidata="lidata3" title="平均日销量：" :selected="listtable3" @click="change($event,3)"></Choosebox>
        <Choosebox :lidata="lidata4" title="SKU销量：" :selected="listtable4" @click="change($event,4)"></Choosebox>
        <div class="form_content_item"><label>月销售额：</label><input type="text" placeholder="请输入您的月销售额" v-model="monthsales"></div>           
      </div>
      <div class="submit" @click="submit" v-if='content'>提交</div> 
      <img src="../assets/form3.svg" alt="已提交申请" v-else class="form_img2">
      </form>
    </div>
    <FooterCN></FooterCN>
  </div>
</template>

<script>
import Header from './common/header.vue'
import FooterCN from './common/footerCN.vue'
import TopCN from './common/topCN.vue'
import DisPlay from './common/display.vue'
import Choosebox from './common/choosebox.vue'
import Sidebanner from './common/sidebanner.vue'

export default {
  name: 'Productscn',
  components: {
    Header,
    FooterCN,
    TopCN,
    DisPlay,
    Choosebox,
    Sidebanner
  },
  data () {
    return {
      typelist:[
        {
          name:'yamaxun',
          url:"/static/imgs/productcn17.png"
        },
        {
          name:'alibaba',
          url:'/static/imgs/productcn18.png'
        },
         {
          name:'aliexpress',
          url:'/static/imgs/productcn19.png'
        },
         {
          name:'lingduan',
          url:'/static/imgs/productcn20.png'
        },
         {
          name:'yilian',
          url:'/static/imgs/productcn21.png'
        },
        {
          name:'mokuai',
          url:'/static/imgs/productcn22.png'
        },
      ],
      typelist2:[
        {
          name:'yamaxun',
          url:"/static/imgs/productcn17.png"
        },
        {
          name:'shopify',
          url:"/static/imgs/productcn24.png"
        },
        {
          name:'bigcommerce',
          url:'/static/imgs/productcn25.png'
        },
         {
          name:'woocommerce',
          url:'/static/imgs/productcn26.png'
        },
         {
          name:'wix',
          url:'/static/imgs/productcn27.png'
        },
         {
          name:'lazada',
          url:'/static/imgs/productcn28.png'
        },
      ],
      sayList: [
        {
          icon: '/static/imgs/productcn35.png',
          name: '莆田无货源拼多多点群卖家',
          content: '2019年4月启动新项目，利用店铺铺货思维，使用ANTDIY的拼多多采集，一键翻译，标题重组，等功能快速将拼多多性价比高的产品铺货到shopee店铺上，出单后使用智能采购自动到拼多多上下单，发货到云仓进行打包发货。现在10个人的团队操作100+店铺，日均达到1500+单。'
        },
        {
          icon: '/static/imgs/productcn36.png',
          name: '深圳中小跨境卖家',
          content: '2019年3月进军东南亚Shopee和Lazada本土市场，之前公司分AB两个小组，团队25人，日均300单，人均订单13单，使用ANTDIY半年后，订单达到每天2000单左右。在爆款跟卖、货源匹配、智能工具箱、一键代发、快速刊登、多店铺管理等强大功能支持下，人均订单暴涨669%，人均利润暴涨400%。'
        },
      ],
      source: localStorage.getItem('ant_source') || '',
      isshow1:true,
      isshow2:true,
      isshow3:true,
      isshow4:true,
      isshow5:true,
      company:'',
      address:'',
      quantity:'',
      name:'',
      phone:'',
      platform:'',
      daysales:'',
      skusales:'',
      monthsales:'',
      form:false,
      form2:false,
      lidata:[{name:'1-20人'},{name:'20-50人'},{name:'50-150人'}],
      lidata2:[{name:'Amazon'},{name:'Wish'},{name:'速卖通'},{name:'eBay'},{name:'国际站'},{name:'Lazada'},{name:'Shopee'},{name:'国内电商'},{name:'无经验'},{name:'其他'}],
      lidata3:[{name:'0-100单'},{name:'100-500单'},{name:'500-1000单'},{name:'1000单+'} ],
      lidata4:[{name:'0-10'},{name:'10-50'},{name:'50-100'},{name:'100+'}],
      listtable:false,
      listtable2:false,
      listtable3:false,
      listtable4:false,
      content:true,
      errorname:false,
      errorphone:false, 
      picture:'',
      consultion:true
    } 
  },
  methods:{
    changeroute(){
      this.$router.push({
        path:'/cn/solve'
      })
    },
    scrollcartonn(end){
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      let step = (end)/220;
      let d = step
      let count = 0;
      let timer =  setInterval(() => {
        if (count > 30 && count <= 70) {
          d = 3*step
        } else if (count > 10 && count <= 90) {
          d = 2*step
        } else if (count > 0 && count < 100) {
          d = step
        }
        start += d
        window.scrollTo(0, start)
        count++;
        if (count >= 100) {
          clearInterval(timer)
        }
      }, 10);    
    },
    consult(){
      if (window.Tawk_API) {
        window.Tawk_API.maximize();
      }
      return
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      } 
    },
    write(val){
      if(val==1){
        this.errorname=false
        if (document.body.offsetWidth > 767) {
          document.querySelector('.form_content_item2').style.marginBottom='15px'
        }else{
          document.querySelector('.form_content_item2').style.marginBottom='.15rem'
        }
      }else{
        this.errorphone=false
         if (document.body.offsetWidth > 767) {
          document.querySelector('.form_content_item3').style.marginBottom='15px'
        }else{
          document.querySelector('.form_content_item3').style.marginBottom='.15rem'
        }
      }
    },
    goLink (url) {
      window.open(url)
    },
    openstore(){
      this.form=true
      this.content=true
    },
    submit(){ 
      let reg=/^1(3|4|5|6|7|8|9)\d{9}$/
      if(this.name==='' && (this.phone==='' || !reg.test(this.phone))){
        this.errorname=true
        this.errorphone=true
        if (document.body.offsetWidth > 767) {
          document.querySelector('.form_content_item2').style.marginBottom='25px'
          document.querySelector('.form_content_item3').style.marginBottom='25px'
        }else{
          document.querySelector('.form_content_item2').style.marginBottom='.3rem'
          document.querySelector('.form_content_item3').style.marginBottom='.3rem'
        }
      } else if(this.name===''){
        this.errorname=true
        if (document.body.offsetWidth > 767) {
          document.querySelector('.form_content_item2').style.marginBottom='25px'
        }else{
          document.querySelector('.form_content_item2').style.marginBottom='.3rem'
        }
      }else if(this.phone==='' || !reg.test(this.phone)){
        this.errorphone=true
        if (document.body.offsetWidth > 767) {
           document.querySelector('.form_content_item3').style.marginBottom='25px'
        }else{
          document.querySelector('.form_content_item3').style.marginBottom='.3rem'
        } 
      }else{
        this.$axios.get(`https://gateway.antdiy.vip/website/chat/0b5c1899805ec43213876bc1ce2a703b5f2758a1f7052c316fd8a00459e420aa`,{
          params:{
            message: `公司名称：${this.company}\n经营地址：${this.address}\n公司规模：${this.quantity}\n联系人姓名：${this.name}\n手机号：${this.phone}\n正在运营的平台：${this.platform}\n平均日销量：${this.daysales}\nSKU销量：${this.skusales}\n月销售额：${this.monthsales}`
          }
        }).then(res=>{
           this.content=false
        })
      }  
    },
    change(value,index){
      if(index==1){
        this.quantity=value
        this.listtable=!this.listtable
        this.listtable2=false
        this.listtable3=false
        this.listtable4=false
      }else if(index==2){
        this.platform=value
        this.listtable2=!this.listtable2
        this.listtable=false
        this.listtable3=false
        this.listtable4=false
      }else if(index==3){
        this.daysales=value
        this.listtable3=!this.listtable3
        this.listtable=false
        this.listtable2=false
        this.listtable4=false
      }else if(index==4){
        this.skusales=value
        this.listtable4=!this.listtable4
        this.listtable=false
        this.listtable3=false
        this.listtable2=false
      }

      // console.log(value,index)
    },
    close(){
      this.form=false
      this.errorname=false
      this.errorphone=false
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;
    if (document.body.offsetWidth > 767) {
      this.picture='form'
      this.consultion=true
    } else {
      this.picture='mobileform'
      this.consultion=false
    }
    const that=this
    // 监听窗口的变化,由于screenwidth只有初始设置为屏幕宽度,改变屏幕大小时并没有主动变化,watch检测不到,所以需要加一个监听窗口大小的方法,然后持续给screenwidth赋值,这样watch就监听到了
  },
  activated(){
    this.form=false
    this.errorname=false
    this.errorphone=false
    // document.querySelector('.form_background').style.backgroundColor='#FDF5F2'
  },
}
</script>

<style scoped>
.form_background{
  width: 100%;
  background: #FDF5F2;
  position: relative;
}
.form_back{
  width: 100%;
  background: rgba(0,0,0,.5);
  z-index: 999;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
form{
  width: 1200px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding:57px 39px 69px 42px;
}
.form_content{
  overflow: auto;
  height: 360px;
}
form h1{
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700
}
.form_close{
  position: absolute;
  top:57px;
  right: 44px;
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.form_img2{
  display: block;
  width: 800px;
  height: 648px;
  margin: 0 auto;
}
.form_img{
  display: block;
  margin: 0 auto 40px;
}
.form_line{
  margin:30px 0 40px;
  position: relative;
}
.form_line em{
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border: 1px solid rgba(255,96,50,1);
  display: block;
}
.form_block{
  width: 60px;
  height: 8px;
  background: #FC5421;
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.form_content_item{
  text-align: center;
  margin-bottom:15px ;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.form_content_item img{
  width: 8.75px;
  height: 10px;
  margin-right: 6.2px;
}
.form_content_item_necessary{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.form_content_item_error{
  position: absolute;
  left: 33px;
  bottom: -20px;
  color: #ff3530;
  font-size: 14px;
}
.form_content_item_input{
  position: relative;  
}
input{
  width: 566px;
  height: 44px;
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 8px;
  margin-left: 15px;
  padding: 14px 0 14px 18px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: 400;
}
input::-webkit-input-placeholder{
  color: rgba(0,0,0,0.28);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color: rgba(0,0,0,0.28);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color: rgba(0,0,0,0.28);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  color: rgba(0,0,0,0.28);
}
input:hover{
  border: 1px solid rgba(252,83,34,1);
}
label{
  text-align: right;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.28px;
  font-weight: 400;
  display: inline-block;
  width: 163px;
}
.submit{
  width: 114px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 500;
  margin: 40px auto 0;
  line-height: 48px;
  cursor: pointer;
}
.product_consult{
  width: 84px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.12);
  border-radius: 10px;
  position: fixed;
  right: 14px;
  top:300px;
  z-index: 999;
}
.product_consult_box{
  width: 84px;
  height: 76px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}
.product_consult_box2{
  border-radius: 10px 10px 0 0;
}
.product_consult_box3{
  border-radius: 0 0 10px 10px;
}
.product_consult_phone{
  width: 208px;
  height: 76px;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(189,189,189,0.5);
  border-radius: 4px;
  padding: 15px 0 15px 10.5px;
  position: absolute;
  top: 76px;
  right: 90px;
}
.product_consult_phone p{
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 400;
}
.product_consult_phone div{
  display: flex;
  margin-top: 14px;
  align-items: center;
}
.product_consult_phone img{
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.product_consult_wechat{
  width: 104px;
  height: 104px;
  position: absolute;
  top: 152px;
  right: 90px;
}
.product_consult_box:hover{
  background: #FB5422;
  color: #ffffff;
}
.product_consult_box img{
  margin-bottom: 8px;
}
.product_consult_box_img{
  transform: rotate(180deg);
}
.product_situation{
  width: 100%;
}
.product_situation3{
  width: 100%;
}
.product_situation2{
  width: 100%;
  background: #FDF5F2;
  position: relative;
}
.product_situationbox{
  width: 1200px;
  margin:auto;
  padding: 80px 0;
}
.product_situationbox2{
  padding-bottom: 0!important;
}
.product_situationbox_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0.5px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 30px 0;
}
.product_situationbox_subtitle{
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.28px;
  font-weight: 500;
  text-align: center;
}
.product_situationbox_line{
  width: 60px;
  height: 8px;
  background: #FC5421;
  border-radius: 6px;
  margin:24px auto 60px auto;
}
.product_planbox1{
  width:100%;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 1px rgba(141,33,0,0.04);
  border-radius: 11px;
  padding-bottom: 25px;
}
.product_planbox1 div{
  display: flex;
  justify-content: center;
}
.product_planbox2 div{
  display: flex;
  justify-content: center;
}
.product_planbox1_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0.33px;
  text-align: center;
  font-weight: 700;
  padding: 30px 0;
}
.product_planbox2{
  width:100%;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 1px rgba(141,33,0,0.04);
  border-radius: 11px;
  margin: 40px 0 60px 0;
  padding-bottom: 25px;
}
.product_planbox_bottom{
  display: flex;
  justify-content: center;
  align-items: center;
}
.product_planbox_button1{
  width: 164px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  font-weight: 500;
  margin-right: 30px;
  cursor: pointer;
}
.product_planbox_button2{
  width: 114px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  font-weight: 500;
  cursor: pointer;
}
.product_planbox_button1:hover,
.product_planbox_button2:hover,
.product_platform_button:hover{
  background: #E34A1E;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
}
.procuct_antools_line {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* height: 217px; */
}
.procuct_antools_column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 386px;
  height: 325px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(159,37,0,0.07);
  border-radius: 40px;
  margin-bottom: 30px;
}
.procuct_antools_column img{
  width: 78px;
  height: 78px;
}
.procuct_antools_image {
  margin-top: 64px;
}
.procuct_antools_title {
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700;
  margin-top: 32.5px;
}
.procuct_antools_text {
  width: 324px;
  height: 48px;
  font-family: SourceHanSansCN-Normal;
  font-size: 16px;
  color: #8D919B;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
  margin-top: 14px;
}
.procuct_antools_bottom_text {
  height: 40px;
  font-size: 20px;
  color: #222536;
  line-height: 40px;
  font-weight: 400;
  text-align: center;
}
.product_antools_bottom{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.product_antools_bottom2 :first-child{
  margin-right: 0!important;
}
.product_antools_bottom :first-child{
  margin-right: 30px;
}
.product_background{
  background-image: url('/static/imgs/earth.png');
  background-size:100% ;
  background-repeat: no-repeat;
  background-position: bottom;
  padding-bottom: 80px;
}
.product_platform{
  display: flex;
  align-items: center;
}
.product_platform_p{
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0.25px;
  text-align: justify;
  font-weight: 500;
  margin: 0 22.5px;
}
.product_platform_line{
  width: 522.74px;
  height: 1px;
  background-image: linear-gradient(#FFE9DF 39%, #FFCEBC 100%);
}
.product_type{
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
}
.product_type3{
  display: flex;
  margin: 30px 0 40px 202px;
}
.product_type2{
  display: flex;
  margin: 30px 0 40px 404px;
}
.product_type_box{
  width: 182px;
  height: 68px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(154,54,0,0.06);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.product_type_box:last-child{
   margin-right: 0;
}
.product_type_box p{
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0.25px;
  text-align: justify;
  font-weight: 400;
}
.product_type_box img{
  width: 120.42px;
}
.cdiscount{
  width: 124.42px!important;
}
.newegg{
  width: 88.42px!important;
}
.alibaba{
  width: 136.42px!important;
}
.yilian{
  width: 128.42px!important;
}
.lingduan{
  width: 90.42px!important;
}
.mokuai{
  width: 112.42px!important;
}
.product_platform_title{
  font-family: SourceHanSansCN-Medium;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0.33px;
  font-weight: 500;
  text-align: center;
}
.product_platform_button{
  cursor: pointer;
  width: 134px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product_platform_button p{
  width: 66px;
  height: 16px;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 16px;
}
.product_platform_button img{
  margin-left: 4px;
  width:16px;
  height: 16px;
}
.product_display_line{
  width: 60px;
  height: 8px;
  background: #FC5421;
  border-radius: 6px;
  margin:30px auto 50px auto;
}
.product_strength{
  display: flex;
  justify-content: space-between;
}
.product_strength_box{
  width: 292px;
  height: 316px;
  border-radius: 20px;
}
.product_strength_box img{
  width: 110px;
  height: 110px;
}
.product_strength_box div{
  text-align: center;
  margin: 26px 0 31px 0;
}
.product_strength_box_title{
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700;
}
.product_strength_box_subtitle{
  margin-top:15px;
  padding: 0 17px 0 15px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #8D919B;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
}
.product_strength_line{
  width: 1201px;
  height: 1px;
  opacity: 0.3;
  border-bottom: 1px solid rgba(255,96,50,1);
  margin: 28px 0 52px 0;
}
.product_strength_div{
  font-family: SourceHanSansCN-Bold;
  font-size: 36px;
  color: #222536;
  letter-spacing: 0.5px;
  text-align: center;
  font-weight: 700;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
form{
  width: 100%;
  border-radius: .1rem;
  padding:.55rem .69rem .5rem .69rem;
}
form h1{
  font-size: .4rem;
  letter-spacing: 0.005rem;
}
.form_content{
  height: 6rem;
}
.form_close{
  top:.28rem;
  right: .225rem;
  width: .4rem;
  height: .4rem;
}
.form_img2{
  width: 6.1rem;
  height: 5.57rem;
}
.form_img{
  margin: 0 auto .43rem;
  width: 100%;
  height: .78rem;
}
.form_line{
  margin:.33rem auto;
  width: 100%
}
.form_line em{
  height: .01rem;
}
.form_block{
  width: .6rem;
  height: .08rem;
  border-radius: .06rem;
}
.form_content_item{
  margin-bottom:.15rem ;
  display: block;
}
.form_content_item img{
  width: .0875rem;
  height: .1rem;
  margin-right: .062rem;
}
input{
  width: 100%;
  height: .54rem;
  border: .01rem solid rgba(151,151,151,0.5);
  border-radius: .08rem;
  margin-left: 0;
  padding: .14rem 0 .14rem .18rem;
  font-size: .2rem;
  display: block;
}
label{
  font-size: .23rem;
  letter-spacing: 0.0028rem;
  width: auto;
  display: block;
  text-align: left;
  margin-bottom: .15rem;
}
.submit{
  width: 1.51rem;
  height: .56rem;
  box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
  border-radius: .08rem;
  font-size: .24rem;
  letter-spacing: 0.0075rem;
  margin: .4rem auto 0;
  line-height: .56rem;
}
.form_content_item_necessary{
  display: flex;
  align-items: center;
  justify-content:flex-start ;
}
.form_content_item_error{
  left: 0;
  bottom: -.25rem;
  font-size: .14rem;
}
.product_situationbox{
  width: 100%;
  margin:auto;
  padding: .65rem .48rem .8rem .48rem;
}
.product_situationbox3{
  padding: .65rem 0 .8rem 0!important
}
.product_situationbox_title{
  font-size: .48rem;
  line-height: .48rem;
  margin: 0 0 .4rem 0;
}
.product_situationbox_subtitle{
  font-size: .24rem;
  letter-spacing: .0033rem;
}
.product_situationbox_line{
  width: .6rem;
  height: .08rem;
  border-radius: .06rem;
  margin: .25rem auto .69rem auto;
}
.product_img{
  overflow: auto;
}
.product_planbox1{
  height: auto;
  width:100%;
  box-shadow:none;
  border-radius: 0;
  padding-bottom: 0;
  padding: 0 .48rem;
}
.product_planbox1 div{
  display: block;
  padding-bottom: .6rem;
  overflow: auto;
}
.product_planbox2 div{
  display: block;
  overflow: auto;
  padding-bottom: .6rem;
}
.product_planbox1_title{
  width: 4.83rem;
  font-size: .3rem;
  padding: .4rem 0 .5rem 0;
  margin:auto
}
.product_planbox2{
  height: auto;
  width:100%;
  box-shadow:none;
  border-radius: 0;
  padding: 0 .48rem;
  margin: .4rem 0 .5rem 0;
  padding-bottom: 0;
}
.product_planbox_bottom{
  display: flex;
  justify-content: center;
  align-items: center;
}
.product_planbox_button3{
  width: 2.5rem;
  height: .56rem;
  font-family: SourceHanSansCN-Medium;
  font-size: .24rem;
  color: #FFFFFF;
  letter-spacing: .0075rem;
  font-weight: 500;
  background: #FC5322;
  box-shadow: 0 .06rem .08rem 0px rgba(252,83,34,0.1);
  border-radius: .08rem;
  text-align: center;
  line-height: .56rem;
}
.product_planbox_button2{
  width: 1.51rem;
  height: .56rem;
  box-shadow: 0 .06rem .08rem 0px rgba(252,83,34,0.1);
  border-radius: .08rem;
  font-size: .24rem;
  letter-spacing: 0.0075rem;
}
.procuct_antools_column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 3rem;
  height: auto;
  background: #ffffff;
  box-shadow: 0 .02rem .1rem 0px rgba(159,37,0,0.07);
  border-radius: .2rem;
  margin-bottom: .3rem;
}
.procuct_antools_column img{
  width: .62rem;
  height: .62rem;
}
.procuct_antools_image {
  margin-top: .4rem;
}
.procuct_antools_title {
  font-family: SourceHanSansCN-Bold;
  font-size: .22rem;
  letter-spacing: 0.0055rem;
  margin-top: .25rem;
}
.procuct_antools_text {
  width: 2.6rem;
  height: auto;
  font-size: .18rem;
  letter-spacing: 0.0056rem;
  line-height: .24rem;
  margin-top: .2rem;
  line-height: .27rem;
  margin-bottom: .2rem;
}
.product_antools_bottom{
  margin-top: .2rem;
}
.product_antools_bottom :first-child{
  margin-right: .5rem;
}
.product_background{
  background: none;
  padding-bottom: .8rem;
}
.product_platform{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.product_platform_p{
  font-size: .24rem;
  letter-spacing: 0.0033rem;
  margin: 0 .192rem;
}
.product_platform_line{
  width: 2rem;
  height: .01rem;
  background-image: linear-gradient(#FFE9DF 39%, #FFCEBC 100%);
  border-radius: .015rem;
}
.product_type{
  margin-top: .5rem;
  justify-content: space-between;
}
.product_type3{
  margin: 0;
  justify-content: space-between;
  flex-wrap: wrap;
}
.product_type2{
  margin: 0;
  justify-content: space-between;
}
.product_type2 .product_type_box{
  margin-bottom: .5rem;
}
.product_type_box{
  width: 3rem;
  height: 1.15rem;
  background: #FFFFFF;
  box-shadow: 0 .02rem .05rem 0 rgba(154,54,0,0.06);
  border-radius: .08rem;
  margin-right: 0;
  margin-bottom: .3rem;
}
.product_type_box:last-child{
   margin-right: 0;
}
.product_type_box p{
  font-family: SourceHanSansCN-Regular;
  font-size: .24rem;
  color: #222536;
  letter-spacing: 0.25px;
  text-align: justify;
  font-weight: 400;
}
.product_type_box img{
  width: 1.5rem;
}
.cdiscount{
  width: 1.5rem!important;
}
.newegg{
  width: 1.3rem!important;
}
.alibaba{
  width: 2.2rem!important;
}
.yilian{
  width: 1.9rem!important;
}
.lingduan{
  width: 1.3rem!important;
}
.mokuai{
  width: 1.7rem!important;
}
.product_platform_title{
  font-size: .24rem;
  letter-spacing: 0.0033rem;
  margin-top: -0.1rem;
}
.product_platform_button{
  width: 1.9rem;
  height: .56rem;
  box-shadow: 0 .06rem .08rem 0 rgba(252,83,34,0.1);
  border-radius: .08rem;
  margin: .5rem auto 0 auto;
}
.product_platform_button p{
  font-size: .24rem;
  letter-spacing: 0.0075rem;
  width: auto;
  height: auto;
  line-height: .24rem;
}
.product_platform_button img{
  margin-left: .06rem;
  width:.22rem;
  height: .22rem;
}
.product_display_line{
  width: .6rem;
  height: .08rem;
  border-radius:.06rem;
  margin:-.1rem auto .5rem auto;
}
.product_strength{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.product_strength_box{
  width: 3.1rem;
  height: 3.08rem;
  border-radius: .2rem;
}
.product_strength_box img{
  width: .72rem;
  height: .72rem;
}
.product_strength_box div{
  text-align: center;
  margin: .4rem 0 .23rem 0;
}
.product_strength_box_title{
  font-size: .22rem;
  letter-spacing: 0.0055rem;
}
.product_strength_box_subtitle{
  margin-top:.2rem;
  padding: 0 .22rem 0 .22rem;
  font-size: .18rem;
  letter-spacing: 0.005rem;
  line-height: .28rem;
}
.product_strength_line{
  width: 100%;
  height: .01rem;
  opacity: 0.3;
  border-bottom: .01rem solid rgba(255,96,50,1);
  margin: .41rem 0 .6rem 0;
}
.product_strength_div{
  font-size: .36rem;
  letter-spacing: 0.005rem;
  margin-bottom: .45rem;
}
}
</style>
<style>
.top_bg_z {
  width: 1005px;
  height: 583px;
  opacity: 0.15;
  border: 120px solid rgba(246,247,250,1);
  border-radius: 291.5px;
  position: absolute;
  top: 27px;
  left: -636px;
}
@media (max-width: 767px) {
  .top_bg_z {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/productscn.vue